import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { BasketStatus } from '@as-react/common-types';
import { LinkButton, StackInline, TextAlpha } from '@yonderland/andes-react';
import { TrashIcon } from '@yonderland/andes-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetBasketStatusState } from '../../../redux/basket/selectors/BasketSelector';
import { basketActions } from '../../../redux/basket/actions/BasketActions.creators';
export const BasketOverviewHeading = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { isShopLanding } = useAemConfig();
    const status = useSelector(makeGetBasketStatusState());
    const dispatch = useDispatch();
    return (_jsxs(StackInline, { contentAlign: "between", wrap: "nowrap", children: [_jsx(TextAlpha, { as: "h1", variant: "headingS", children: t('checkout.basket.title.page') }), isShopLanding && status === BasketStatus.READY && (_jsx(LinkButton, { testId: "reset_basket", text: t('basket.reset'), iconLeft: { source: TrashIcon, size: 'sm' }, onClick: () => dispatch(basketActions.createResetBasketForShopLanding()) }))] }));
};
